import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './SimilarAnime.css';

const toSlug = (title) => title.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, '');

const SimilarAnime = ({ animeId }) => {
  const [similarAnime, setSimilarAnime] = useState([]);

  useEffect(() => {
    const fetchSimilarAnime = async () => {
      try {
        const response = await fetch(`https://api.jikan.moe/v4/anime/${animeId}/recommendations`);
        const data = await response.json();
        setSimilarAnime(data.data || []);
      } catch (error) {
        console.error('Error fetching similar anime:', error);
      }
    };

    fetchSimilarAnime();
  }, [animeId]);

  return (
    <div className="similar-anime-container">
      <h3>More Anime Like This</h3>
      <div className="similar-anime-cards">
        {similarAnime.map((anime) => (
          <Link
            key={anime.entry.mal_id}
            to={`/animehub/anime/${anime.entry.mal_id}-${toSlug(anime.entry.title)}`}
            className="similar-anime-card"
          >
            <img
              src={anime.entry.images?.jpg?.image_url || 'https://via.placeholder.com/150'}
              alt={anime.entry.title}
              className="similar-anime-image"
            />
            <p>{anime.entry.title}</p>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default SimilarAnime;
